import { Brand } from 'constants/brand';
import Trades from 'components/Clients/Trades';
import Fees from 'components/Clients/Fees';

export const CLIENT_PROFILE_COMMISSION_SOURCE_TAB_CONFIG = {
  [Brand.FM]: Trades,
  [Brand.GP]: Trades,
  [Brand.DAY1]: Fees,
};
